<template>
  <div class="module_page page_content institution" aria-label="Institution Course Reporing Widget view content page">

    <div class="row page-heading">
      <div class="col-8 input module_heading" role="heading" aria-level="1">
        <span class="module_icon ic-inst"></span>
        <label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}</label>
      </div>
      <div class="col-4 btn_container" v-if="isSuperAdmin">
        <b-btn v-if="widget.uuid" @click="deleteWidgetKey">delete</b-btn>
        <b-btn v-else @click="generateWidgetKey">generate</b-btn>
      </div>
    </div>

    <div class="page_content_container">

      <institution-menu :uuid="uuid" :active="'courseWidget'"></institution-menu>

      <div class="row pg_content">
  		  <div class="col-12">
          <template v-if="widget.uuid">
            <div class="row">
              <div class="col-12 pg_fld_sec">
                <div class="row pg_fld_row">
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Key</label>
                        </div>
                        <div class="fld_input">
                          <label class="val">{{widget.key}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="row" style="margin-top: 30px;">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Client ID</label>
                        </div>
                        <div class="fld_input">
                          <label class="val">{{widget.clientId}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <div class="row">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Shared Secret</label>
                        </div>
                        <div class="fld_input">
                          <label class="val">{{widget.secret}}</label>
                        </div>
                      </div>
                    </div>
                    <div class="row" style="margin-top: 30px;">
                      <div class="col-12">
                        <div class="fld_label">
                          <label class="label">Embeddable Script</label>
                        </div>
                        <div class="fld_input">
                          <textarea rows="5" style="height: 125px; width: 625px;" v-model="widget.embeddableScript"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="text-center mt-5">
              <b-jumbotron>
                <h4 class="text-center ace_sec_txt">Course Reporting Widget is currently not configured for this institution.</h4>
              </b-jumbotron>
            </div>
          </template>
        </div>
    </div>
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import InstitutionMenu from './InstitutionMenu'
import InstitutionHeader from './InstitutionHeader'

export default {
  name: 'institutionWidgetDetail',
  props: ['uuid'],
  components: {
    InstitutionMenu,
    InstitutionHeader
  },
  data: () => {
    return {
      widget: {},
      userObject: JSON.parse(localStorage.getItem('userobj')),
      superAdminPermissionName: 'SUPERADMIN_PERMISSION'
    }
  },
  mounted () {
    this.loadWidgetDetail({uuid: this.uuid, type: 'COURSE_REPORTING'}).then(res => {
      if (res) {
        this.widget = res
      }
    })
  },
  methods: {
    ...mapActions([
      'loadWidgetDetail',
      'loadGenerateWidgetKeyAndSecret',
      'loadDeleteWidgetKeyAndSecret'
    ]),
    generateWidgetKey () {
      this.loadGenerateWidgetKeyAndSecret({uuid: this.uuid, type: 'COURSE_REPORTING'}).then(res => {
        if (res) {
          this.widget = res
        }
      })
    },
    deleteWidgetKey () {
      this.loadDeleteWidgetKeyAndSecret(this.widget.uuid).then(res => {
        this.widget = {}
      })
    }    
  },
  computed: {
    ...mapState({
      'institution': state => state.institution.institution,
      'permission': state => state.user.permission
    }),
    isSuperAdmin () {
      let userObject = this.userObject
      let permission = userObject.permission || this.permission
      return permission.name === this.superAdminPermissionName
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/institution/components/InstitutionCourseWidgetDetail.vue